import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Button, Form, Tooltip, Icon } from 'sup-ui';
import { checkInstallApi, checkInstallStatusApi, checkTaskStatusApi } from 'root/services/manager';
import CommonIcon from 'root/components/Icon';

import { useDispatch } from 'react-redux';
import { common } from 'root/store/actions';

import messages from './messages';
import CommonModal from 'root/components/CommonModal';
import successImg from 'root/assets/images/illustrator_partitionsucceeded.png';

import creatingImg from 'root/assets/images/illustrator_inpartition.png';
import styles from './index.less';
interface PropsType {
  visible: boolean;
  setVisible: any;
}

let loopTimer: any = null;

const InitNoDataPage = (props: PropsType) => {
  const intl = useIntl();
  const dispath = useDispatch();

  const { visible, setVisible } = props;

  const [status, setStatus] = useState('success'); //    checking:  success:创建成功  failed:创建失败
  const [dataInfo, setDataInfo] = useState<any>({});

  useEffect(() => {
    if (!visible && status === 'success') {
      dispath(common.updateSuposDir({ hasSuposCatalogue: true }));
      sessionStorage.setItem('hasSuposCatalogue', 'true');
    }
    if (!visible) return;
    getData();
  }, [visible]);

  const onCancel = () => {
    setVisible(false);
  };

  const getData = () => {
    checkTaskStatusApi().then((res) => {
      setStatus('checking');
      // 如果当前存在检测任务 直接获取任务状态
      if (res.data) {
        checkInstallStatus();
        return;
      }
      // 发起检测任务;
      checkInstallApi({ type: 'RUNNING' }).then(() => {
        checkInstallStatus();
      });
    });
  };

  // 轮询获取状态
  const loopGetData = () => {
    clearTimeout(loopTimer);
    loopTimer = setTimeout(() => {
      checkInstallStatus();
    }, 1000 * 5);
  };

  const checkInstallStatus = () => {
    checkInstallStatusApi().then((res: any) => {
      const { data = {} } = res;
      const { result } = data;
      setDataInfo(data);

      // 检测结束，关闭定时器
      if (result) {
        setStatus(result);
        clearTimeout(loopTimer);
        if (result === 'SUCCESS') {
          setStatus('success');
          return;
        }
        setStatus('failed');
        return;
      }
      loopGetData();
    });
  };

  const renderStatusContext = () => {
    switch (status) {
      case 'checking':
        return (
          <div className={styles.creating}>
            <div>
              <div>
                <img src={creatingImg} className={styles.statusImg} />
              </div>
              <span className={styles.createText}>{intl.formatMessage(messages.checking)}</span>
            </div>
          </div>
        );
      case 'success':
        return (
          <div className={styles.success}>
            <div>
              <img src={successImg} className={styles.statusImg} />
              <div>
                <div>{intl.formatMessage(messages.checkSuccess)}</div>
              </div>
            </div>
          </div>
        );
      case 'failed':
        return (
          <div className={styles.failed}>
            <div className={styles.failedTitle}>
              <CommonIcon type="tixing40" className={styles.warning} />
              <span className={styles.failedTitle}>{intl.formatMessage(messages.failedTitle)}</span>
            </div>

            <ul className={styles.failedText}>
              {dataInfo?.errorDetails?.map((item: any) => {
                const { error, cause } = item;
                return (
                  <li className={styles.item} key={error}>
                    <div className={styles.name}>
                      <span className={styles.text} title={error}>
                        {error}
                      </span>
                    </div>
                    <div className={styles.noPass}>{intl.formatMessage(messages.noPass)}</div>
                    <div>{cause}</div>
                  </li>
                );
              })}
              {dataInfo?.warnDetails?.map((item: any) => {
                const { error, cause } = item;
                return (
                  <li className={styles.item} key={error}>
                    <div className={styles.name}>
                      <span className={styles.text} title={error}>
                        {error}
                      </span>
                    </div>
                    <div className={styles.warn}>{intl.formatMessage(messages.warn)}</div>
                    <div>{cause}</div>
                  </li>
                );
              })}
            </ul>
          </div>
        );
    }
  };

  const renderCheckItem = () => {
    return (
      <div className={styles.tip}>
        <h3 className={styles.tipTitle}>{intl.formatMessage(messages.checkItems)}</h3>
        <ul>
          {dataInfo?.checkResultItems?.map((item: any) => (
            <li key={item.checkId}>{item.description}</li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className={styles.init_data_page}>
      <CommonModal
        visible={visible}
        onCancel={onCancel}
        width="556px"
        className={styles.checkEnvModal}
        footer={
          ['checking'].includes(status)
            ? [
                <Button type="primary" key="add" onClick={onCancel} disabled={status === 'checking'}>
                  {intl.formatMessage(messages.sure)}
                </Button>,
              ]
            : [
                <Button type="primary" key="add" onClick={onCancel}>
                  {intl.formatMessage(messages.sure)}
                </Button>,
                <Button onClick={getData} key="retest">
                  {intl.formatMessage(messages.retest)}
                </Button>,
              ]
        }
        height="auto"
      >
        <div className={styles.modalContent}>
          <div className={styles.title}>
            {intl.formatMessage(messages.checkEnv)}
            <Tooltip overlayStyle={{ maxWidth: '500px' }} title={renderCheckItem()}>
              <Icon type="question-circle" className={styles.questionIcon} />
            </Tooltip>
          </div>
          {renderStatusContext()}
        </div>
      </CommonModal>
    </div>
  );
};

export default Form.create()(InitNoDataPage);
